export * as attributes from './attributes'
export * from './room-type'
